import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, TextField, Paper } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function ReceiveGoodsScreen() {
  const navigate = useNavigate();
  const [successModal, setSuccessModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessModal(true);
  };

  const handleSuccessClose = () => {
    setSuccessModal(false);
    navigate('/prototype/incoming-deliveries');
  };

  return (
    <ScreenFrame
      title="Receive goods"
      actions={<Button component={Link} to="/prototype/operator" variant="outlined" size="small">Operator home</Button>}
    >
      <Paper sx={{ p: 2, maxWidth: 500 }}>
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="Supplier" margin="normal" />
          <TextField fullWidth label="Lot number" margin="normal" />
          <TextField fullWidth label="Quantity" type="number" margin="normal" />
          <Button type="submit" variant="contained" sx={{ mt: 2 }}>Register delivery</Button>
        </form>
      </Paper>
      <ConfirmDialog open={successModal} title="Delivery registered" message="Delivery saved. Go to incoming deliveries?" onConfirm={handleSuccessClose} onCancel={handleSuccessClose} confirmLabel="OK" />
    </ScreenFrame>
  );
}
